import { useState, useEffect } from 'react';
import { Network } from '@capacitor/network';
import { isCapacitor } from '../utils/platform';

export function useNetworkManager() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    async function checkNetworkStatus() {
      if (isCapacitor) {
        // Vérification initiale pour Capacitor
        const status = await Network.getStatus();
        setIsOnline(status.connected);

        // Écouteur pour Capacitor
        Network.addListener('networkStatusChange', (status) => {
          setIsOnline(status.connected);
        });
      } else {
        // Écouteurs pour le web
        function handleOnline() { setIsOnline(true); }
        function handleOffline() { setIsOnline(false); }
        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);
        return () => {
          window.removeEventListener('online', handleOnline);
          window.removeEventListener('offline', handleOffline);
        };
      }
    }

    checkNetworkStatus();

    // Nettoyage pour Capacitor
    return () => {
      if (isCapacitor) {
        Network.removeAllListeners();
      }
    };
  }, []);

  return { isOnline };
}